module.exports = __webpack_public_path__ + "img/20210120.713cddb9.gif";